/**
 * A Promise which resolves when the DOM is ready.
 */
export const domReady = new Promise<void>(resolve => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => resolve())
  } else {
    resolve()
  }
})

/*
 * Wraps an element with another element.
 */
export function wrapElement(toWrap: HTMLElement, wrapper: HTMLElement) {
  if (!toWrap.parentNode) return

  wrapper = wrapper || document.createElement('div')

  toWrap.parentNode.insertBefore(wrapper, toWrap)
  return wrapper.appendChild(toWrap)
}

/*
 * Unwraps the children of an element.
 */
export function unwrapElement(element: HTMLElement) {
  const parent = element.parentNode
  if (!parent) return
  while (element.firstChild) parent.insertBefore(element.firstChild, element)
  parent.removeChild(element)
}

/**
 * Get a v4 UUID
 */
export function uuid(): string {
  if ('randomUUID' in globalThis.crypto) {
    return globalThis.crypto.randomUUID()
  }

  let s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

/**
 * Debounce a function
 */
export function debounce<T extends (...args: Parameters<T>) => ReturnType<T>>(
  callback: T,
  wait: number,
) {
  let timeout: any

  const debounced = (...args: Parameters<T>) => {
    clearTimeout(timeout)
    timeout = setTimeout(() => callback(...args), wait)
  }

  return debounced
}
